import React, { useState, useMemo } from 'react'
import { Tabs } from 'antd'
import styled from 'styled-components'

const StyledTabs = styled(Tabs)`
  .ant-tabs-nav-list {
    border: 1px solid #2b4db9;
    border-radius: 12px;
  }
`

export const BlockedContentTab = () => {
  const [activeTab, setActiveTab] = useState('videos')

  const items = useMemo(
    () => [
      { key: 'videos', label: 'Videos', children: <div>Blocked Videos</div> },
      {
        key: 'comments',
        label: 'Comments',
        children: <div>Blocked Comments</div>,
      },
    ],
    [],
  )

  return (
    <div className="tabs-container">
      <StyledTabs activeKey={activeTab} items={items} onChange={setActiveTab} />
    </div>
  )
}
